// extracted by mini-css-extract-plugin
export default {"section":"Button_section__VIl7o"};